import '../App.css';
import React, { useState, useRef } from "react";
import bgGrad from '../images/bg-grad2.png';
import { Link as RouterLink } from "react-router-dom";
import WatchNowContainer from '../components/watchNowContainer.js'
import youTubeIcon from '../images/youtube-icon.png';
import rumbleIcon from '../images/rumble-icon.png';

function Watch() {
  const [ playNow, setPlayNow ] = useState(false);
  const dialogRef = useRef(null);
  const [email, setEmail] = useState('');
  const [isValid, SetIsValid] = useState(true);
  const [isCancelled, SetIsCancel] = useState(false);

  const handleClickWatchNow = () => {
    dialogRef.current?.showModal();
  };

  const handleCancelDialog = () => {
    dialogRef.current?.close();
    SetIsCancel(true);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    
    if (validateEmail(email)){
      SetIsValid(true);
      CallAPI(email);
      dialogRef.current?.close();
      setPlayNow(true);
    }else{
      if(!isCancelled){
        SetIsValid(false);
      }else{
        SetIsValid(true);
      }
    }
    SetIsCancel(false);
  };

  const validateEmail = (email) => {
    // don't remember from where i copied this code, but this works.
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if ( re.test(email) ) {
        return true;
    }
    else {
        return false;
    }
  }

  function CallAPI(email) {
    fetch(`https://artclubmovie-bff.azurewebsites.net/api/v1/users`, {
      method: "post",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-functions-key':'99MSHOEY0PhS88Hnc6D1mpkR9dfeEepOCjdbNL2sVhfcAzFu81UA6Q=='
      },
      //make sure to serialize your JSON body
      body: JSON.stringify({
        email: email
      })
    })
    .then(data => data.json())
    .then(json => {
      setPlayNow(true);
    })
    .catch((error) => {

    });;
  }

  return (
      <div>
        <div id='watch-now-wrapper'>
              {
                playNow ? 
                <WatchNowContainer/>
                :
                <div>
                  <img alt={bgGrad} id='watch-now-overlay-img' src='https://imagedelivery.net/oAhaaM1LvhaOBT0E-_ZQUg/17c5b679-dbd3-4124-8b03-1fa16913fe00/public'></img>
                  <div id='watch-now-overlay'>
                    <div id='watch-now-overlay-row'>
                      <svg onClick={handleClickWatchNow} id='watch-now-play-button-svg' viewBox="0 0 24 24" >
                        <path d="M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,3.5 C7.30557963,3.5 3.5,7.30557963 3.5,12 C3.5,16.6944204 7.30557963,20.5 12,20.5 C16.6944204,20.5 20.5,16.6944204 20.5,12 C20.5,7.30557963 16.6944204,3.5 12,3.5 Z M9.0527864,8.5854102 C9.1625594,8.3658642 9.41205933,8.26236922 9.63961698,8.328815 L9.7236068,8.3618034 L16.1055728,11.5527864 C16.2023365,11.6011683 16.2807978,11.6796295 16.3291796,11.7763932 C16.4389526,11.9959392 16.3720486,12.2576361 16.1823574,12.3998148 L16.1055728,12.4472136 L9.7236068,15.6381966 C9.65417908,15.6729105 9.57762255,15.690983 9.5,15.690983 C9.25454011,15.690983 9.05039163,15.5141078 9.00805567,15.2808586 L9,15.190983 L9,8.80901699 C9,8.73139445 9.01807255,8.65483791 9.0527864,8.5854102 Z" id="playsvgpath"></path>
                      </svg>
                      <span onClick={handleClickWatchNow} id='watch-now-play-button-text'>Watch Now</span>
                      <RouterLink target="_blank" rel="noreferrer" to="https://www.givesendgo.com/ArtClubMovie"><button id='watch-now-donate-button' className='button-centered'>Donate</button></RouterLink>
                    </div>
                  </div>
                  <dialog id='email-consent-dialog' ref={dialogRef}>
                    <p id='email-consent-dialog-header'>Enter email address</p>
                    <p id='email-consent-dialog-text-body'>To view the movie please enter your email address. This is to ensure you're a human, We'll never share your email.</p>
                    {
                      isValid ? <div></div> :
                      <p id='email-consent-dialog-text-body-validation'>Please enter a valid email address</p>
                    }
                    <form onSubmit={handleSubmit}>
                      <div id='email-consent-dialog-text'>
                        <label >
                          Email:
                          <input type="text" value={email} onChange={handleEmailChange} />
                        </label>
                      </div>
                      <p id='email-consent-dialog-text-body'>By clicking confirm, you agree to our <a href="https://www.privacypolicies.com/live/06aa7dcc-b797-461a-8eca-2acb9e0c0939" target="_blank">Terms and Conditions</a> </p>
                      <div id='email-consent-dialog-buttons'>
                        <button className='button-centered-modal' onClick={handleCancelDialog}>Cancel</button>
                        <button className='button-centered-modal' id="confirmBtn" value="default">Confirm</button>
                      </div>
                    </form>
                  </dialog>
              </div>                          

              }
              
              
        </div>
        <div id='watch-now-details-wrapper'>
          <div id='watch-now-details-grid'>
    
              <div id='watch-now-details-about-row-1'>
                <span id='watch-now-details-about-header-text'>Art Club</span>
              </div>
              <div id='watch-now-details-about-row-2'>
                <span id='watch-now-details-about-text'>Documentary | 1h 15m | 2024 | HD</span>
              </div>
              <div id='watch-now-details-about-row-3'>
                <p id='watch-now-details-about-text'>
                  Kevin Lundberg, along with the Lee family, produced this firsthand account of their family’s experience with public school indoctrination and the transgender social contagion.
                </p>
                <p id='watch-now-details-about-text'> 
                  This film takes an intimate look at this important issue, incorporates expert testimony, and offers advice for any parent, grandparent, aunt, uncle or friend to protect the children in their lives and stand up for truth.
                </p>
                <p id='watch-now-details-about-text'>
                  Art Club is a labor of love that was made possible by the support of many people. We’re committed to making this film widely available for free, but we can’t do it alone. Help us turn this project into a tidal wave of action by sharing the film & paying it forward!
                </p>
              </div>
            <div id='watch-now-details-aside-3'>  
              <p id='watch-now-details-about-text'>Directed by: Kevin Lundberg</p>
              <p id='watch-now-details-about-text'>Featuring: Erin Lee, Jonathan Lee, Alex Newman, Dr. Quentin Van Meter, David Barton, Dr. Jennifer Bauwens, Michael Farris, January Littlejohn, Kevin Lundberg </p>
            </div>
            <div id='watch-now-details-aside-5'>  
              <p id='watch-now-details-about-text'>Audio Language: English</p>
              <p id='watch-now-details-about-text'>Subtitles Language: English, Spanish</p>
              <p id='watch-now-details-about-text'>Also available on:</p>
              <div id='watch-now-details-available-on'>
                <RouterLink target="_blank" rel="noreferrer" to="https://youtu.be/YGtG2Uh7O6A?si=2HqcrOb_3v0YHx47">
                  <img src={youTubeIcon} alt=''></img>
                </RouterLink>
                <RouterLink target="_blank" rel="noreferrer" to="https://rumble.com/v586fxx-art-club-2024.html">
                  <img src={rumbleIcon} alt=''></img>
                </RouterLink>
              </div>
            </div>
            <div id='watch-now-details-about-row-4'>
              <span id='get-involved-details-about-header-text'>Get Involved</span>
            </div>
            <div id='watch-now-details-about-row-5'>
              <p id='watch-now-details-about-text'>For a public showing at your church, theatre or other meetings, please contact us at ArtClubMovie@gmail.com</p>
              <p id='watch-now-details-about-text'>For more information on how to get involved please visit <a href="https://www.protectkidscolorado.org" target="_blank">ProtectKidsColorado.org</a></p>
            </div>
          </div>
          <div id='home-grid-footer'>
            <div id='home-grid-footer-row-item-1'>
                <span id='home-grid-footer-row-item-1-text' >© 2025 Powered and secured by JL Studios</span>
            </div>
          </div>
        </div>
      </div>
    );
}

export default Watch;
